<template>
  <AssetsTable
    smaller-gap-bottom
    :display-has-label="false"
    :with-title="false"
    no-border
    :select-item-route="selectItemRoute"
    :sort-order="sortOrder"
  />
</template>
<script>
import AssetsTable from './assets-table';

export default {
  components: {
    AssetsTable,
  },
  props: {
    id: { type: String, required: true },
    filters: { type: Array, default: () => [] }, // filters => array of { key, value }
    selectItemRoute: { type: Function, default: null },
    sortOrder: { type: Array, default: null },
    removeFiltersOnDestroy: { type: Boolean, default: true },
  },
  watch: {
    id() {
      // When the id changes, we need to refresh the assets
      this.getFilteredAssets();
    },
  },
  created() {
    // This component is used to display a filtered list of assets
    // - filter the assets
    this.getFilteredAssets();
  },
  beforeDestroy() {
    if (this.removeFiltersOnDestroy) {
      this.$store.commit('assets/RESET_FILTERS');
    }
  },
  methods: {
    getFilteredAssets() {
      this.$store.commit('assets/SET_FILTERS', this.filters);
      this.$store.dispatch('assets/refreshGetAssets', { sortOrder: this.sortOrder });
    },
  },
};
</script>
